import { useEffect, useState } from 'react';
import { getCookie } from '../components/utils/utils';

export const usePriceEstimationPolling = (isLoggedIn: boolean) => {
  const [activeEstimations, setActiveEstimations] = useState<string[]>([]);

  useEffect(() => {
    if (!isLoggedIn) {
      setActiveEstimations([]);
      return;
    }

    // Initial fetch of active estimations
    const fetchActiveEstimations = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/price-estimation/active`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'X-CSRF-TOKEN': getCookie('csrf_access_token') || '',
            }
          }
        );

        if (response.ok) {
          const data = await response.json();
          if (data.estimations && Array.isArray(data.estimations)) {
            setActiveEstimations(data.estimations.map((est: any) => est._id));
          }
        }
      } catch (error) {
        console.error('Error fetching active estimations:', error);
      }
    };

    fetchActiveEstimations();
    
    // Check for new active estimations every 30 seconds
    const intervalId = setInterval(fetchActiveEstimations, 30000);

    return () => clearInterval(intervalId);
    
  }, [isLoggedIn]);

  // Polling logic for active estimations
  useEffect(() => {
    if (activeEstimations.length === 0) return;

    const intervals: NodeJS.Timeout[] = [];

    activeEstimations.forEach(id => {
      // Poll each active estimation
      const interval = setInterval(async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/price-estimation/status/${id}`,
            {
              method: 'GET',
              credentials: 'include',
              headers: {
                'X-CSRF-TOKEN': getCookie('csrf_access_token') || '',
              }
            }
          );

          if (response.ok) {
            const data = await response.json();
            if (data.status === 'completed' || data.status === 'failed' || data.status === 'incomplete') {
              // Remove from active list
              setActiveEstimations(prev => prev.filter(eid => eid !== id));
            }
          } else {
             // If 404 or other error, remove it to stop polling
             if (response.status === 404 || response.status === 403) {
                 setActiveEstimations(prev => prev.filter(eid => eid !== id));
             }
          }
        } catch (error) {
          console.error(`Error polling estimation ${id}:`, error);
        }
      }, 10000); // Poll every 10 seconds (webhooks handle the heavy lifting)

      intervals.push(interval);
    });

    return () => {
      intervals.forEach(clearInterval);
    };
  }, [activeEstimations]);
};

